<template>
  <el-dialog
    :title="(isEdit ? '编辑' : '添加') + '物料入库信息'"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    width="900px"
    heigh="200px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="form"
      status-icon
      :rules="rules"
      ref="form"
      label-position="right"
      label-width="100px"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="选择仓库" prop="WarehouseId">
            <RemoteSelect
              v-model="form.WarehouseId"
              url="AccessoryEntryRecords/GetWareHouseList?WarehouseType=1"
              code="WarehouseId"
              name="WarehouseName"
              placeholder="选择仓库"
            >
            </RemoteSelect>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物料名称" prop="MaterialName">
            <!--  -->
            <!-- <RemoteSelect
              v-model="form.MaterialName"
              url="VehicleScrap/GetList"
              code="ScrapName"
              name="ScrapName"
            >
            </RemoteSelect> -->
            <CascaderSelect
              v-model="form.MaterialName"
              need="ScrapName"
            ></CascaderSelect>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="重量" prop="TotalWeight">
            <el-input
              v-model="form.TotalWeight"
              placeholder="重量"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单位">
            <el-input
              v-model="form.Unit"
              placeholder="单位"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider content-position="left">物料来源</el-divider>

      <div style="height: 400px; overflow: auto">
        <el-table
          :data="tableData"
          ref="table"
          highlight-current-row
          @selection-change="selectionChange"
          @current-change="handleCurrentChange"
        >
          <!-- :header-cell-class-name="cellClass"    :selectable="selectable"-->
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column type="index" width="70"> </el-table-column>
          <el-table-column
            label="车辆信息表主键"
            prop="CarId"
            show-overflow-tooltip
            hidden
          ></el-table-column>
          <el-table-column
            label="入场编号"
            prop="RegistrationNum"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="车牌号" show-overflow-tooltip
            ><template slot-scope="{ row }">
              {{ row.LicensePlate | gang }}
            </template>
          </el-table-column>
          <el-table-column label="重量" prop="Weightitem" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.Weightitem"
                @change="handleChange"
                :min="0"
                :max="parseInt(form.Weight)"
                label="描述文字"
              ></el-input-number>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <el-pagination
        ref="breadCrumb"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100]"
        @size-change="getTableData(1)"
        @current-change="getTableData()"
        :current-page.sync="pageIndex"
        :page-size.sync="pageSize"
        :total="pageTotal"
      ></el-pagination> -->
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="save" :loading="loading"
        >保 存</el-button
      >
      <el-button type="canale" @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import UploadPhoto from "@/components/UploadPhoto.vue";
export default {
  props: ["item"],
  components: {
    UploadPhoto,
  },
  data() {
    return {
      DisableSelection: true, // 全选按钮隐藏
      visible: false,
      loading: false,
      isable: true,
      isEdit: false,
      form: {},
      rules: {
        WarehouseId: [
          {
            required: true,
            message: "不可为空",
          },
        ],
        MaterialName: [
          {
            required: true,
            message: "不可为空",
          },
        ],
        TotalWeight: [
          {
            required: true,
            message: "不可为空",
          },
          this.$g.validNumber,
        ],
      },
      pageIndex: 1,
      pageSize: 10,
      pageTotal: 0,
      data: [],
      selectdata: [],
      tableData: [],
      scraplist: {},
      EntryId: "",
    };
  },

  watch: {
    item: {
      handler: function (v) {
        // if (v.EntryId) {
        //   this.EntryId = v.EntryId;
        //   this.isEdit = true;
        //   this.$get("AccessoryEntryRecords/GetModel", {
        //     EntryId: v.EntryId,
        //   }).then((r) => {
        //     this.init({ ...r.Result });
        //   });
        // } else {
        // this.$get("MaterialInventory/GetRegistrationNum", {
        //   PageNumber: this.pageIndex,
        //   PageSize: this.pageSize,
        // }).then((r) => {
        //   this.tableData = r.Result;
        //   this.pageTotal = r.Rows;
        // });
        this.getTableData();
        this.init({});
        this.isEdit = false;
        // }
        this.visible = true;
      },
    },
    "form.MaterialName": {
      handler: function (v) {
        if (v != "") {
          this.$get("VehicleScrap/GetList", {
            ScrapName: v[1],
          }).then((r) => {
            this.$set(this.form, "Unit", (r.Result || [])[0].Unit);
          });
        } else {
          this.form.Unit = "";
        }
      },
    },
  },
  methods: {
    init(form) {
      this.form = { ...form };
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
    },

    handleChange(values) {},
    selectionChange(selection) {
      if (!this.form.TotalWeight) {
        this.$message.warning("请先输入总重量再进行分配");
        return;
      }
      this.selectdata = selection;
      this.calculate();
      // this.tableData.forEach((r) => {
      //   r.Weightitem = 0;
      // });
      // let WeightNow = this.form.TotalWeight / selection.length;
      // selection.forEach((item) => {
      //   this.tableData.filter((r) => {
      //     if (r.RegistrationNum == item.RegistrationNum) {
      //       r.Weightitem = WeightNow;
      //     }
      //   });
      // });
    },
    //按车分配重量
    calculate() {
      var chooseCarList = new Array();
      if (this.selectdata != "[]") {
        var rows = this.selectdata;
        if (rows.length == 0) return;
        chooseCarList = rows.map((item) => ({
          CarId: item,
        }));
      }
      var totalWeight = this.form.TotalWeight; //总重量
      var chooseCarCount = chooseCarList.length; //选中行个数
      var number = Math.floor(totalWeight / chooseCarCount); //平分重量如: 51/5 10
      var remain = totalWeight % chooseCarCount; //余数 如51%5=1
      chooseCarList.forEach((row, i) => {
        row.Weight = number;
        if (i < remain) {
          row.Weight += 1;
        }
      });
      //遍历车辆列表,选中项可进行编辑
      this.tableData.forEach((item) => {
        var v = chooseCarList.filter((p) => p.CarId.CarId == item.CarId);
        if (v != null && v.length > 0) {
          item.Weightitem = v[0].Weight;
          item.disable = false; //true 禁止文本框输入 false允许文本框输入
        }
      });
    },

    handleCurrentChange(row) {
      this.$emit("currentrow", row);
    },

    // // 更新表格数据
    // updateTableData() {
    //   // 根据当前页码和分页大小计算应该显示的数据
    //   // 例如，当前页码为2，分页大小为10，则需要显示数据的索引从10开始，到19结束
    //   const startIndex = this.pageSize * (this.currentPage - 1);
    //   const endIndex = startIndex + this.pageSize;
    //   const newData = this.tableData.slice(startIndex, endIndex);

    //   // 将表格重新渲染
    //   this.$refs.table.clearSelection();
    //   this.$refs.table.setData(newData);

    //   // 在重新渲染后勾选之前选中的行
    //   this.selectedRows.forEach((row) => {
    //     const index = newData.findIndex((item) => item === row);
    //     if (index >= 0) {
    //       this.$refs.table.toggleRowSelection(newData[index], true);
    //     }
    //   });
    // },

    getTableData(pageIndex) {
      if (pageIndex) {
        this.pageIndex = pageIndex;
      }
      this.$get("MaterialInventory/GetItem", {
        PageNumber: this.pageIndex,
        PageSize: this.pageSize,
      }).then((r) => {
        let list = r.Result;
        let pageTotal = r.Rows;
        if (list.length > 0) {
          let row = list[0];
          this.$refs.table.setCurrentRow(row);
        }
        this.tableData = list;
        // this.pageTotal = pageTotal;
      });
    },

    //节点拖
    save() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.selectdata.length == 0) {
          this.$message.error("请选择物料来源");
          return;
        }

        let weigh = 0;
        this.selectdata.forEach((item) => {
          weigh += item.Weightitem;
        });
        if (weigh != this.form.TotalWeight) {
          this.$message.error("重量分配错误");
          return;
        }
        let params = { ...this.form };
        params.MaterialName = params.MaterialName[1];
        params.selectdata = this.selectdata;
        this.$post("MaterialInventory/MaterialEntry", params).then((r) => {
          this.$message.success("入库成功");
          this.visible = false;
          this.$emit("success");
        });

        this.loading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/themes/common";

h4 {
  margin-top: 10px;
  @include font_color("text-color2");
}
.el-table .DisableSelection .cell .el-checkbox__inner {
  display: none;
  position: relative;
}
.el-table .DisableSelection .cell:before {
  content: "";
  position: absolute;
}
</style>
